module.exports = __webpack_public_path__ + "static/media/Tredence-Logo.aadd5e43.svg";